import React, { useEffect } from "react";
import { default as MainHeaderApp } from "@appsinti/ui-core/header";
import { ArrowLeftIcon } from "@etiquette-ui/icons";
import { useData } from "../../../../../../data";
import SpecialDayItem from "../../components/SpecialDayItem";
import Loader from "../../../../../../components/charts/components/Loader";
import Card from "../../../../containers/Card";
import Content from "../../../../containers/Content";
const { parseDate } = require("@appsinti/stats-utils");
import NewItemButton from "../../../../components/NewItemButton";
import LineChart from "../../../../../../components/charts/line";

const Main: React.FC = () => {
  const {
    sales,
    fetchSales,
    fechSpecialDaysConfig,
    specialDaysConfig,
  } = useData();

  useEffect(() => {
    fechSpecialDaysConfig();
    fetchSales();
  }, []);

  const specialDays = (sales ?? []).find((el) => el.key === "specialDays");

  return (
    <>
      <MainHeaderApp
        title={"Edit Special Days"}
        icon={<ArrowLeftIcon styles={{}} />}
        backButtonLocation="../.."
      />
      <Content>
        {specialDays && (
          <LineChart
            dataObject={specialDays}
          />
        )}
        <Card
          body={
            specialDaysConfig ? (
              <>
                {Object.entries(specialDaysConfig).sort(([, valueA], [, valueB]) => {
                  const calculateValueA = parseDate(valueA.date)?.getTime() ?? 0;
                  const calculateValueB = parseDate(valueB.date)?.getTime() ?? 0;
                  return calculateValueA - calculateValueB;
                }).map(([key, value]) => (
                  <SpecialDayItem key={key} specialDay={value} dayId={key} />
                ))}
                <NewItemButton to="day" />
              </>
            ) : (
              <Loader />
            )
          }
        />
      </Content>
    </>
  );
};

export default Main;
